// Header phrase per language, selected at runtime by the home_language_banner experiment variant.
// TODO(translation): en + hi verified; kn/te/mr/bn/ml/ta fall back to English until translated.
export const LANGUAGE_BANNER_HEADER: Record<string, string> = {
  en: 'Change App language',
  hi: 'अपनी पसंदीदा भाषा चुनें',
  kn: 'ಆ್ಯಪ್‌ನ ಭಾಷೆಯನ್ನು ಬದಲಿಸಿ',
  te: 'యాప్ భాషను మార్చండి',
  mr: 'अ‍ॅपची भाषा बदला',
  bn: 'অ্যাপের ভাষা পরিবর্তন করুন',
  ml: 'Change App language',
  ta: 'ஆப்பின் மொழியை மாற்றவும்',
};
